export class FormObjectDroppedFlags {
    skipAddLastRow: boolean = false;
}
